<div class="travel-comfort">
    <div class="section-wrapper">
        <div class="twoColLayout">
            <div class="f-col">
                <h2 class="title-text p-bottom-8x" [innerHTML]="content?.['b2b.booking.travelsmarter'].replace('with Saudia','with \u003Cbr\u003ESaudia')"></h2>
            </div>

            <div class="f-col">
                <ul class="featues-benefits">
                    <li>
                        <span class="icon-section">
                            <mat-icon fontSet="material-symbols-outlined" class="done-icon">done</mat-icon>
                        </span>

                        <div class="list-content">
                            <h3 class="title-text">{{content?.['b2b.booking.businessbenefits']}}</h3>
                            <p class="description-text">{{content?.['b2b.booking.accessfares']}}</p>
                        </div>
                    </li>

                    <li>
                        <span class="icon-section">
                            <mat-icon fontSet="material-symbols-outlined" class="done-icon">done</mat-icon>
                        </span>

                        <div class="list-content">
                            <h3 class="title-text">{{content?.['b2b.booking.preferredseat']}}</h3>
                            <p class="description-text">{{content?.['b2b.booking.addcomfort']}}</p>
                        </div>
                    </li>

                    <li>
                        <span class="icon-section">
                            <mat-icon fontSet="material-symbols-outlined" class="done-icon">done</mat-icon>
                        </span>

                        <div class="list-content">
                            <h3 class="title-text">{{content?.['b2b.booking.policyaligned']}}</h3>
                            <p class="description-text">{{content?.['b2b.booking.createbookings']}}</p>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>